import React from 'react'
import { Chip, Grid } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import KPITile from '../../governance/kpi/components/KPITile'
import { WidgetFrame, WidgetUnavailable } from './WidgetFrame'

// Renders one KPI section's headline tiles — the server defines the tiles
// (gauge/number/trend/breakdown) and KPITile draws them unchanged, so new
// KPIs appear on wallboards without client changes.
const KpiWidget = ({ widget, data }) => {
  const { viz } = useTheme().palette
  const slug = widget.config?.slug
  const section = data?.[`kpi:${slug}`] ?? data?.[`kpi:clinical-records`]

  const healthColor =
    section?.healthScore == null
      ? undefined
      : section.healthScore >= 80
        ? viz.good
        : section.healthScore >= 60
          ? viz.warning
          : viz.critical

  return (
    <WidgetFrame
      title={section?.name ? `KPIs · ${section.name}` : 'KPIs'}
      accent={viz.series}
      action={
        section?.healthScore != null ? (
          <Chip
            size="small"
            label={`${Math.round(section.healthScore)}%`}
            sx={{
              fontWeight: 700,
              color: healthColor,
              bgcolor: 'rgba(148, 163, 184, 0.12)',
            }}
          />
        ) : null
      }
    >
      {!section || section.error ? (
        <WidgetUnavailable />
      ) : section.kpis.length === 0 ? (
        <WidgetUnavailable label="No KPI data for this section yet" />
      ) : (
        // TileShell sizes itself with viewport breakpoints (lg = 2 of 12
        // columns — a sliver on a TV). Halving the column count makes each
        // headline tile a third of the card, so three tiles fill the row;
        // alignContent centres them vertically in tall cards.
        <Grid
          container
          spacing={1.5}
          columns={6}
          sx={{ flex: 1, overflow: 'hidden', alignContent: 'center' }}
        >
          {section.kpis.map((kpi) => (
            <KPITile key={kpi.key} kpi={kpi} />
          ))}
        </Grid>
      )}
    </WidgetFrame>
  )
}

export default KpiWidget
